import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';

export const Wrapper = styled(Flex)<{
  $isClickable: boolean;
  $selected: boolean;
}>`
  align-items: center;

  ${({ $isClickable, $selected, theme }) => css`
    padding: ${theme.spacing(1)};
    border: 1px solid ${theme.colors.quinaryGrey};
    margin-bottom: ${theme.spacing(1)};
    transition: ${theme.transitions.duration.standard} ease;

    ${$isClickable &&
    css`
      &:hover {
        @media (hover: hover) {
          background-color: ${theme.colors.primaryBlue};
          p,
          span {
            color: ${theme.colors.white} !important;
          }
          cursor: pointer;
        }
      }
    `}

    ${$selected &&
    css`
      background-color: ${theme.colors.primaryBlue};
      p,
      span {
        color: ${theme.colors.white} !important;
      }
    `}
  `}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ImageWrapper = styled(Box)`
  position: relative;
  min-width: 88px;
  max-width: 88px;
  height: 88px;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const ProductImage = styled(NextImage)`
  object-fit: contain;
  inset: 0;
`;
